const AboutSection = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '專業師資',
      description: '經驗豐富的專業教練團隊，完善的課程規劃，讓家長安心託付'
    },
    {
      icon: 'ri-team-line',
      title: '品格培養',
      description: '透過團隊活動培養孩子的溝通協調能力、責任感和領導才能'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '健康運動',
      description: '多元運動課程，培養運動習慣，促進身心健康發展'
    },
    {
      icon: 'ri-trophy-line',
      title: '多元學習',
      description: '結合運動、科學、藝術等多元課程，啟發孩子無限潛能'
    }
  ];

  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            為什麼選擇CMAP寒假營隊？
          </h3>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            我們致力於為孩子提供最優質的寒假營隊體驗，透過專業的課程設計和豐富的活動內容，讓每個孩子都能在學習中快樂成長
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center text-emerald-600">
                  <i className={`${feature.icon} text-xl sm:text-2xl`}></i>
                </div>
              </div>
              <h4 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">{feature.title}</h4>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h4 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
              專業教學團隊，用心陪伴成長
            </h4>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              我們的教學團隊擁有豐富的兒童教育經驗和專業認證，每位老師都經過嚴格的培訓。我們提供安全的學習環境，制定完善的課程規劃，確保每個孩子都能在快樂的氛圍中學習成長。
            </p>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <div className="w-3 h-3 flex items-center justify-center text-white">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                </div>
                <span className="text-sm sm:text-base text-gray-700">專業兒童教育認證師資</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <div className="w-3 h-3 flex items-center justify-center text-white">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                </div>
                <span className="text-sm sm:text-base text-gray-700">完善的安全防護措施</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <div className="w-3 h-3 flex items-center justify-center text-white">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                </div>
                <span className="text-sm sm:text-base text-gray-700">小班制教學品質保證</span>
              </div>
            </div>
          </div>
          <div className="relative order-1 lg:order-2">
            <img 
              src="https://public.readdy.ai/ai/img_res/6274318e523541ff81761ba4eb5db98c.jpg"
              alt="專業教師指導孩子學習活動"
              className="rounded-xl shadow-lg w-full h-auto object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
